import { AfterViewChecked, ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { AlertPolygonDialogComponent } from '@core_n/alert-polygon/alert-polygon.component';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import * as enums from '../common/enums';
import * as settings from '../common/settings';
import { DisplayFilterComponent } from '../display-filter/display-filter.component';
import { GlobalSettingsComponent } from '../global-settings/global-settings.component';
import { MsgMngrService } from '../msg/msg-mngr.service';
// import { ExternalIpComponent } from '../external-ip/external-ip.component';
import { SensorWindowComponent } from '../sensor-window/sensor-window.component';
import { SideNavigationService } from '../side-navigation/side-navigation.service';
import { AroSensorTabDetailsComponent } from './../../../app/aro/aro-sensor-tab-details.component';
import { Animations } from './../Animations';
import { PlaybackDialogComponent } from './playback-dialog/playback-dialog.component';
//import { MsgMngrService, MsgMngrService } from '@core_n/msg/msg-mngr.service';

@Component({
  selector: 'side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
  animations: [
    Animations.OutIn,
    Animations.ButtonClicked,
    Animations.ButtonClickedInverted
  ]
})
export class SideNavigationComponent implements OnInit, AfterViewChecked {

  upperBarHeight: number;
  plotAroBottom: number = 0;
  isPlayback: boolean;

  displayFilter: DisplayFilterComponent;
  globalSettings: GlobalSettingsComponent;

  private plotAroWidth: number = 0;

  whitelistClicked: boolean = true;

  @ViewChild('sidenav', { static: true }) public sidenav: MatSidenav;
  // @ViewChild('plotAroCard', { read: ElementRef }) public plotAroCard: ElementRef;
  @ViewChild('leftPanel', { read: ElementRef }) public leftPanel: ElementRef;
  @ViewChild('rightPanel', { read: ElementRef }) public rightPanel: ElementRef;

  // @ViewChild('trackAroContainer', { read: ViewContainerRef }) trackAroContainer: ViewContainerRef;
  // @ViewChild('plotAroContainer', { read: ViewContainerRef }) plotAroContainer: ViewContainerRef;
  @ViewChild('displayFilterContainer', { read: ViewContainerRef }) displayFilterContainer: ViewContainerRef;
  @ViewChild('globalSettingsContainer', { read: ViewContainerRef }) globalSettingsContainer: ViewContainerRef;
  @ViewChild('aroTableContainer', { read: ViewContainerRef }) aroTableContainer: ViewContainerRef;

  // submenu stuff
  @ViewChild('plusButton', { read: ElementRef }) public plusButton: ElementRef;
  @ViewChild('plusMenu', { read: ElementRef }) public plusMenu: ElementRef;
  public InOut: boolean = true; // true = in, out = false

  constructor(
    private sidenavService: SideNavigationService,
    //private aroService: AroService,
    private cdref: ChangeDetectorRef,
    private compFactResolver: ComponentFactoryResolver,
    private msgMngrService: MsgMngrService,
    private dialog: MatDialog) {
    settings.userSettings.menuCloser.subscribe(x => {
      this.InOut = true;
    });

    this.whitelistClicked = settings.userSettings.acousticUseWhiteListOn;
  }

  ngOnInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }

  ngAfterViewInit() {
    this.displayFilter =
      this.displayFilterContainer.createComponent(this.compFactResolver.resolveComponentFactory(DisplayFilterComponent)).instance;
    this.globalSettings =
      this.globalSettingsContainer.createComponent(this.compFactResolver.resolveComponentFactory(GlobalSettingsComponent)).instance;
  }

  ngAfterViewChecked(): void {
    this.plotAroBottom = settings.statusBarHeight;
    this.upperBarHeight = settings.upperBarHeight;
    this.cdref.detectChanges();
    this.isPlayback = settings.userSettings.isPlayback.value;

  }

  displayFilterShown() {
    return this.displayFilter ? this.displayFilter.isShown : false;
  }

  onShowDisplayFilter() {
    if (this.displayFilter.isShown) {
      this.displayFilter.hide();
    }
    else {
      this.globalSettings.hide();
      this.displayFilter.show();
    }
  }

  globalSettingsShown() {
    return this.globalSettings ? this.globalSettings.isShown : false;
  }

  onShowGlobalSettings() {
    if (this.globalSettings.isShown) {
      this.globalSettings.hide();
    }
    else {
      this.displayFilter.hide();
      this.globalSettings.show();
    }
  }

  onWhiteListClick() {
    this.whitelistClicked = !this.whitelistClicked;
    settings.userSettings.setAcousticUseWhiteListOn(this.whitelistClicked);
  }

  sensorWindowClicked() {
    this.dialog.open(SensorWindowComponent, SensorWindowComponent.createDialogConfig(100, 200));
  }

  externalIpClicked() {
    // this.dialog.open(ExternalIpComponent, ExternalIpComponent.createDialogConfig(100, 200));
    // this.InOut = true;
  }

  onPlaybackClick() {
    this.dialog.open(PlaybackDialogComponent, PlaybackDialogComponent.createDialogConfig(100, 200));
    this.InOut = true;
  }

  onNaiNatClick() {
    this.dialog.open(AlertPolygonDialogComponent, AlertPolygonDialogComponent.createDialogConfig(100));
    this.InOut = true;
  }

  onSensorClick() {
    this.dialog.open(AroSensorTabDetailsComponent, AroSensorTabDetailsComponent.createDialogConfig(100));
    this.InOut = true;
  }

  // resetSensorClicked() {
  //   mainMapMngr.resetSensorDrawer();
  // }

  sensorRefresh() {
    mainMapMngr._sensorsDrawer.objectsLayer.refresh();
  }

  sensorReset() {
    mainMapMngr._sensorsDrawer.objectsLayer.reset();
  }

  isAdmin() {
    if (settings.userSettings.userPerm == enums.Permission.ADMIN)
      return true;
    return false;
  }

  xMenuCalc(): number {
    if (!this.plusButton || !this.plusMenu)
      return 0;
    let plusRect = this.plusButton.nativeElement.getBoundingClientRect();
    let menuRect = this.plusMenu.nativeElement.getBoundingClientRect();
    if (plusRect && menuRect) {
      if (this.InOut)
        return plusRect.x;
      else
        return plusRect.x - plusRect.width - 10;
    }
    return 0;
  }

  yMenuCalc(): number {
    if (!this.plusButton || !this.plusMenu)
      return 0;
    let plusRect = this.plusButton.nativeElement.getBoundingClientRect();
    let menuRect = this.plusMenu.nativeElement.getBoundingClientRect();
    if (plusRect && menuRect) {
      return plusRect.y - (menuRect.height / 2) + (plusRect.height / 2);
    }
    return 0;
  }

  onPlusClick() {
    this.InOut = !this.InOut;
  }
}
